import { render, staticRenderFns } from "./popup-wrap.vue?vue&type=template&id=d50d881e"
import script from "./popup-wrap.vue?vue&type=script&lang=js"
export * from "./popup-wrap.vue?vue&type=script&lang=js"
import style0 from "./popup-wrap.vue?vue&type=style&index=0&id=d50d881e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports